<template>
  <div>
    <div class="special_box" id="special_box">
      <section class="specials">
        <h2>Our Special <span>Features</span></h2>
        <ul class="special_details">
          <li class="special">
            <i class="iconfont icon-Tablebooking"></i>
            <div class="special_item">
              <h3>Book a Table</h3>
              <p>
                Reserve a table in advance at your favourite dine-in place with
                All Eat
              </p>
            </div>
          </li>
          <li class="special">
            <i class="iconfont icon-superperformence"></i>
            <div class="special_item">
              <h3>Super Performence</h3>
              <p>Super fast performance and easy to place an order.</p>
            </div>
          </li>
          <li class="special">
            <i class="iconfont icon-yuding"></i>
            <div class="special_item">
              <h3>Pre Order</h3>
              <p>
                customer can do pre-order and you will get your order on right
                time
              </p>
            </div>
          </li>
          <li class="special">
            <i class="iconfont icon-filter1"></i>
            <div class="special_item">
              <h3>Get the best</h3>
              <p>
                Filter restaurants according to their services hygiene ratings,
                and delivery modes
              </p>
            </div>
          </li>
          <li class="special">
            <i class="iconfont icon-search"></i>
            <div class="special_item">
              <h3>Customer Support</h3>
              <p>
                Get in touch with our support team and ask anything about the
                order or restaurant.
              </p>
            </div>
          </li>
          <li class="special">
            <i class="iconfont icon-liuyanjianyi"></i>
            <div class="special_item">
              <h3>Unparalleled customer service</h3>
              <p>
                Get in touch with our friendly team ready to support you about
                takeaway orders and payments.
              </p>
            </div>
          </li>
        </ul>
      </section>
    </div>
    <div class="blog_box" id="blog_box">
      <section class="blogs">
        <h2>Our New <span>Blog</span></h2>
        <p class="title">
          The Best of All Eat: read the UK's top restaurants' food blog, and
          find the secret recipes from chefs and get exclusive offers from All
          Eat.
        </p>
        <ul class="blog_list">
          <li v-for="item in blogList" :key="item.id">
            <img
              :src="item.yoast_head_json.og_image[0].url"
              @click="goLink(item)"
            />
            <h3>{{ item.yoast_head_json.title }}</h3>
            <div class="desc">
              <span class="item">
                <i class="iconfont icon-touxiang"></i>
                {{ item.yoast_head_json.author }}
              </span>
              <div direction="vertical"></div>
              <span class="item time" style="flex: 1">
                <i class="iconfont icon-24gf-calendar"></i>
                {{ $moment(item.date_gmt).format(" MMMM D YYYY") }}
              </span>
              <div direction="vertical"></div>
              <span class="item">
                <i class="iconfont icon-comment-full"></i>
                {{ item.featured_media }}&nbsp; comment
              </span>
            </div>
          </li>
        </ul>
      </section>
    </div>
    <div class="reviews_box">
      <section class="reviews">
        <h3>Customer valuable Reviews</h3>
        <div class="fake-indicate"></div>

        <!-- swiper 部分 -->
        <swiper :options="swiperOption" ref="mySwiper" id="mySwiper">
          <swiper-slide
            v-for="(item, index) in reviewList"
            :key="item.cuisineId"
            class="reviewBox"
            :style="{ background: colorList[index % 3] }"
          >
            <div
              class="review_container"
              :style="{ background: colorList[index % 3] }"
            >
              <div class="rate" >
                <i class="iconfont icon-xingxing"></i>
                <i class="iconfont icon-xingxing"></i>
                <i class="iconfont icon-xingxing"></i>
                <i class="iconfont icon-xingxing"></i>
                <i class="iconfont icon-xingxing"></i>
              </div>
              <p class="comment">{{ item.comment }}</p>
            </div>
            <div class="person_msg">
              <h4>{{ item.name }}</h4>
            </div>
          </swiper-slide>

          <!-- 可选的控件 -->
          <!--分页器-->
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </section>
    </div>
  </div>
</template>

<script>
// import { postGateway } from "@/request";
export default {
  data() {
    return {
      blogList: [],
      swiperOption: {
        //幻灯片放映方向
        direction: "horizontal", //通常不与左右按钮一同使用
        slidesPerView: 3,
        spaceBetween: 30,
        //分页器配置项
        pagination: {
          el: ".swiper-pagination", //分页器的类名
          clickable: true, // 点击分页器跳切换到相应的幻灯片
          bottom: 0,
        },
        //幻灯片播放配置项
        loop: false, //是否循环播放
        speed: 1000, // 发生页面切换动画时，动画的切换速度
        autoplay: {
          delay: 3000, // 幻灯片停留时间
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
          stopOnLastSlide: true, // 切换到最后一个slide时是否停止自动切换。（loop模式下无效）。
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          320: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        on: {
          slideChangeTransitionEnd: function () {
            // console.log(this.activeIndex); //每次切换结束时，在控制台打印现在是第几个slide
          },
        },
      },
      colorList: ["#f2709c", "#82e182", "#9562ff"],
      reviewList: [
        {
          name: "Amanda Dunell",
          comment:
            "This has to be the best Chinese we have ever tasted! Food is always hot and every dish cooked perfectly. Delivery was bang on time too",
          rate: 5,
          avatar:
            "https://alleatapp.net/wp-content/uploads/2022/08/1636341731587.jpg",
        },
        {
          name: "Robin Lewis",
          comment:
            "This has to be the best Chinese we have ever tasted! Food is always hot and every dish cooked perfectly. Delivery was bang on time too",
          rate: 3,
          avatar:
            "https://alleatapp.net/wp-content/uploads/2022/08/Robin-Lewis_3-copy.jpg",
        },
        {
          name: "Michael Murphy",
          comment:
            "5 Stars everytime !! Food delicious any tweaks to order or problems sorted out very quickly. Excellent customer service and prompt hot delivery everytime My go-to for good Chinese Ps curries and salt& pepper food excellent",
          rate: 5,
          avatar: "https://alleatapp.net/wp-content/uploads/2022/09/poul.png",
        },
        {
          name: "Amanda Dunell",
          comment:
            "This has to be the best Chinese we have ever tasted! Food is always hot and every dish cooked perfectly. Delivery was bang on time too",
          rate: 5,
          avatar:
            "https://alleatapp.net/wp-content/uploads/2022/08/1636341731587.jpg",
        },
        {
          name: "Robin Lewis",
          comment:
            "This has to be the best Chinese we have ever tasted! Food is always hot and every dish cooked perfectly. Delivery was bang on time too",
          rate: 3,
          avatar:
            "https://alleatapp.net/wp-content/uploads/2022/08/Robin-Lewis_3-copy.jpg",
        },
        {
          name: "Michael Murphy",
          comment:
            "5 Stars everytime !! Food delicious any tweaks to order or problems sorted out very quickly. Excellent customer service and prompt hot delivery everytime My go-to for good Chinese Ps curries and salt& pepper food excellent",
          rate: 5,
          avatar: "https://alleatapp.net/wp-content/uploads/2022/09/poul.png",
        },
      ],
    };
  },
  created() {
    this.getBlogList();
    this.$moment.locale("en"); // 设为英语
  },
  mounted() {},
  methods: {
    getBlogList() {
      fetch("https://alleatapp.net/wp-json/wp/v2/posts")
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          this.blogList = data.splice(0, 3);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    goLink(item) {
      window.open(item.link);
    },
  },
};
</script>

<style lang="scss" scoped>
$mainColor: #aa0bc0;
$greenColor: #26d07c;
$yellowColor: #ffa132;
.special_box {
  background: #f7f9fb;
  font-family: "Roboto", Sans-serif;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
  .specials {
    width: 1200px;
    h2 {
      color: #000;
      text-align: center;
      color: #000000;
      text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
      margin: 0px 0px 40px 0px;
      font-family: "Roboto", Sans-serif;
      font-size: 36px;
      font-weight: 700;
      span {
        color: $mainColor;
        font-family: "Playfair Display", Sans-serif;
        font-size: 36px;
        font-weight: 700;
        font-style: italic;
        transition: all ease-in 0.2s;
        color: #ac0dbc;
        text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
        &:hover {
          color: $greenColor;
        }
      }
    }
    .special_details {
      display: flex;
      flex-flow: wrap;
      width: 100%;
      justify-content: space-between;
      .special {
        display: flex;
        align-items: center;
        cursor: default;
        padding-left: 10px;

        &:hover {
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.5);
            background-color: #fff;
            border-radius: 6px;
            
            i {
            color: #fff;
            background-color: $mainColor;
          }
        }

        i {
          display: inline-block;
          padding: 20px;
          margin-right: 20px;
          color: #999;
          font-size: 43px;
          font-weight: bold;
          background-color: #fff;
          box-shadow: -1px 7px 15px 0px rgba(0, 0, 0, 0.07);
          border-radius: 50px;
          transition: all ease-in 0.2s;
        }
        .special_item {
          display: flex;
          flex-direction: column;
          width: 260px;
          h3 {
            padding: 0 0 0 0;
            margin-bottom: 0px;
            color: #111633;
            font-size: 21px;
            font-weight: 700;
            line-height: 25px;
          }
          p {
            padding: 0;
            margin-bottom: 20px;
            color: #565656;
            font-size: 15px;
            font-weight: 400;
            line-height: 25px;
          }
        }
      }
    }
  }
}
.blog_box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 50px 0;
  background: #f7f9fb;
  font-family: "Roboto", Sans-serif;
  .blogs {
    width: 1140px;
    h2 {
      margin: 0 0 17px 0;
      color: #000;
      text-shadow: 0px 0px 10px rgba(0, 0, 0, 0.3);
      margin: 0px 0px 17px 0px;
      font-family: "Roboto", Sans-serif;
      font-size: 36px;
      font-weight: 700;
      text-align: center;
      span {
        color: $mainColor;
        transition: all ease-in 0.2s;
        font-family: "Playfair Display", Sans-serif;
        font-size: 36px;
        font-weight: 700;
        font-style: italic;
        &:hover {
          color: $greenColor;
        }
      }
    }
    .title {
      width: 534px;
      margin-bottom: 30px;
      margin-left: 26%;
      color: #646363;
      font-size: 16px;
      font-weight: 400;
      line-height: 26px;
      text-align: center;
    }
    .blog_list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1140px;
      li {
        display: inline-flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        width: 340px;
        height: 270px;
        img {
          width: 340px;
          height: 202px;
          border-top-right-radius: 6px;
          border-top-left-radius: 6px;
          cursor: pointer;
          border-radius: 8px;
          object-fit: cover;
        }
        h3 {
          width: 100%;
          margin: 0 0 9px;
          color: #78909c;
          font-size: 15px;
          font-weight: 700;
          text-align: left;
          margin-top: 10px;
        }
        .desc {
          display: inline-flex;
          align-items: center;
          width: 100%;
          .item {
            font-size: 12px;
            i {
              margin-right: 6px;
              color: #54595f;
              font-size: 16px;
            }
          }
          .time {
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }
}
.reviews_box {
  font-family: "Roboto", Sans-serif;
  margin: 50px auto;
  background-color: #fff;
  width: 1110px;
  .reviews {
    width: 1140px;
    h3 {
      padding-bottom: 10px;
      color: #404040;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
    }
    .fake-indicate {
      height: 4px;
      position: relative;
      width: 30px;
      background: #2575fc;
      border-radius: 2px;
      margin: 0 auto;
      margin-bottom: 30px;
      left: 15px;
      &::after {
        content: "";
        position: absolute;
        color: #0c5adb;
        left: -27px;
        top: 0;
        display: inline-block;
        height: 4px;
        width: 4px;
        border-radius: 50%;
        background-color: #0c5adb;
        -webkit-box-shadow: 9px 0 0 0 currentColor, 18px 0 0 0 currentColor;
        box-shadow: 9px 0 0 0 currentColor, 18px 0 0 0 currentColor;
      }
    }
    h4 {
      display: inline-block;
      width: 100%;
      margin-bottom: 40px;
      font-size: 17px;
      line-height: 24px;
      text-align: center;
    }
    .swiper-container {
      width: 1140px !important;
      .swiper-wrapper {
        position: relative;
        height: 450px;
        .reviewBox {
          display: flex !important;
          align-items: flex-start !important;
          flex-direction: column;
          widows: 340px;
          padding: 30px;
          border-radius: 10px;
          box-sizing: border-box;
          padding: 40px 25px 60px 25px;
          box-shadow: 9px 11px 14px 0 rgba(0,0,0,.1);
          color: #fff;
          .review_container {
            .rate {
                display: flex;
                justify-content: center;
                .iconfont {
                    color: #fff;
                    font-size: 18px;
                    margin-right: 5px;
                }
            }
            
            .comment {
              margin: 0 0 20px 0;
              margin-top: 10px !important;
              font-family: "Roboto", Sans-serif;
              color: #fff;
              font-size: 14px;
              line-height: 18px;
              text-align: center;
              transition: all 0.4s ease;
            }
          }
        }
        .person_msg {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          img {
            display: inline-block;
            width: 80px;
            height: 80px;
            margin-bottom: 20px;
            border: 4px solid #fff;
            border-radius: 50%;
          }
          h4 {
            display: block;
            color: #000;
            font-size: 18px;
            font-weight: 700;
            text-align: center;
            transition: color 0.3s;
            -webkit-transition: color 0.3s;
            margin-bottom: 0;
          }
        }
      }
    }
  }
}

</style>
